export const FETCH_SPACES_REQUEST = 'FETCH_SPACES_REQUEST'
export const SET_SPACES_DATA = 'SET_SPACES_DATA'
export const FETCH_SPACE_DETAIL_REQUEST = 'FETCH_SPACE_DETAIL_REQUEST'
export const SET_SPACE_DETAIL_DATA = 'SET_SPACE_DETAIL_DATA'
